import styled from 'styled-components'

const Container = styled.div`
    padding: 0 15px;
`

const Wrapper = styled.div`
    max-width: 1108px;
    margin: 0 auto;
    width: 100%;
`
const SellerInfo = styled.div`
    border-radius: 9px;
  background-color: #f8f8f8;
  padding : 16px 22px;
  display: flex;
  margin-top: 15px;
  > div {
      flex:1;
       :last-child {
            max-width: 420px;
      } 
      > h3 {
          font-size: 20px;
          font-family: 'latobold';
          margin: 4px 0;
      }
      > h4 {
          font-size: 18px;
          font-family: 'latobold';
        margin: 4px 0;

      }
      h6 {
           font-size: 18px;
          font-family: 'latobold';
      }
      > p {
            margin: 2px 0;
          
      }
      .rateHeading {
          padding-top: 15px;
      }
      .favorite {
          svg {
              color: red;
          }
      }
  }
`
const ActionSection = styled.div`
    display: flex;
    gap: 30px;
    span {
        color: #2525ed;
        cursor: pointer;
    }
    p{
        color:grey
    }
`
const CustomerReview = styled.div`
    
    > h2 {
        font-size:38px;
        margin:30px 0;
        span {
            color: #ff6008;
                    cursor: pointer;

        }
    }
   

`
const ShortingSection = styled.div`
            margin-bottom:30px;
`
const ReviewBox = styled.div`
    border-radius: 9px;
    background-color: #f8f8f8;
    padding : 16px 22px;
    display: flex;
    flex-direction: column;
    margin-bottom: 15px;
    > h3 {
        font-size: 22px;
    }
    > div {
        p {
            span {
            color: #ff6008;
        }
        }
    }
    >p {
        padding: 18px 0 26px 0;
        margin:0;
        font-size: 14px;
    }
`
const RatingWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    .MuiBox-root {
        margin: 0 10px;
        display: flex;
    }
    .MuiRating-label {
        margin: 0;
    }
`



export { Container, Wrapper, SellerInfo, ActionSection, CustomerReview, ShortingSection, ReviewBox, RatingWrapper }